import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type RouterService from '@ember/routing/router-service';
import { findRecord, query } from '@ember-data/json-api/request';

export default class AuthOrdersEditRoute extends Route {
  @service declare store: Store;
  @service declare router: RouterService;
  async model(params) {
    const id = params.id;
    const req_order = await this.store.request(findRecord('order', id));
    const order = req_order.content.data;
    if (order.status !== 'created') {
      alert('Diese Bestellung kann nicht mehr bearbeitet werden.');
      return this.router.transitionTo('auth.orders.index');
    }
    return order;
  }
}
